import { Component, Input, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../pattern/sidebar/sidebar.component';
import { Toast } from 'primeng/toast';
import { LoadingToastComponent } from '../../ui/loading-toast/loading-toast.component';

@Component({
  selector: 'app-private-layout',
  imports: [RouterOutlet, SidebarComponent, LoadingToastComponent],
  template: `
    <div class="flex flex-1 h-[100vh] overflow-hidden">
      <app-sidebar />
      <div class="flex flex-1 flex-col overflow-x-hidden">
        @if (false) {
          <div class="flex flex-row items-center justify-between p-2">
            <div class="flex flex-col">
              @if (title) {
                <p>{{ title }}</p>
              }
              @if (description) {
                <p>{{ description }}</p>
              }
            </div>
            <div class="flex flex-row items-center gap-2">
              <ng-content select="[actions]" />
            </div>
          </div>
        }

        <div class="p-1 md:p-4 flex-1 overflow-y-scroll">
          <router-outlet />
        </div>
      </div>
    </div>
    <app-loading-toast />
  `,
})
export class PrivateLayoutComponent {
  @Input() title: string | undefined = undefined;
  @Input() description: string | undefined = undefined;
  @ViewChild('toast') toast!: Toast;
}
